/* eslint-disable react/prop-types */
import React, { useState } from 'react'
import { Alert, AlertTitle, List, ListItem, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { MUIFormFileInput } from '../../../../../@Common/Form/FileInput/FormFileInput'
import { useForm } from 'react-hook-form'
import ErrorIcon from '@mui/icons-material/Error'
import { ModalContainer } from '../../../../../Modals/ModalContainer'

function ImportEventsModal({
    onClickSubmit,
    onClickClose,
}) {
    const [processing, setProcessing] = useState(false)
    const [importErrors, setImportErrors] = useState([])
    const [showErrorMessage, setShowErrorMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState(null)
    const { control, watch, handleSubmit } = useForm({
        defaultValues: {
            eventsFile: null,
        },
        mode: 'onChange',
    })

    const onSubmit = async (data) => {
        try {
            setProcessing(true)
            setImportErrors([])
            const result = await onClickSubmit(data)
            if (result?.errors?.length > 0) {
                setImportErrors(result.errors)
            } else {
                onClickClose()
            }
        } catch (err) {
            setShowErrorMessage(true)
            setErrorMessage(err?.message || null)
        } finally {
            setProcessing(false)
        }
    }

    return (
        <div>
            <ModalContainer
                title="Import Events"
                maxWidth="sm"
                fullWidth="true"
                processing={false}
                showProgressBar={processing}
                hideModal={() => { }}
                actions={{
                    primaryAction: { label: 'Import', onClick: handleSubmit(onSubmit), disabled: watch('eventsFile') === null ? watch('eventsFile') === null : processing },
                    secondaryAction: { label: 'Cancel', onClick: onClickClose, disabled: processing },
                }}
            >
                <Typography component="div">
                    {importErrors.length > 0 ? (
                        <Box sx={{ overflow: 'scroll', overflowX: 'hidden', maxHeight: '400px', maxWidth: '1000px', marginBottom: '24px' }}>
                            <Alert icon={<ErrorIcon />} sx={{ marginTop: '0px', backgroundColor: '#FDEDED', color: '#5F2120', '& .MuiAlert-icon': { color: '#d32f2f' } }} severity="error">
                                <AlertTitle sx={{ fontWeight: 'bold' }}>Please correct the following errors in the file and try again.</AlertTitle>
                                <List sx={{ listStyleType: 'disc', listStylePosition: 'inside' }}>
                                    {importErrors.map((error, index) => (
                                        // eslint-disable-next-line react/no-array-index-key
                                        <ListItem sx={{ display: 'list-item' }} key={index}>{error}</ListItem>
                                    ))}
                                </List>
                            </Alert>
                        </Box>
                    ) : (
                        <>
                            <Box>
                                To import events, make sure your file adheres to the following standards:
                            </Box>
                            <ul style={{ listStyle: 'inside', margin: '.75em' }}>
                                <li>File should be CSV format.</li>
                            </ul>
                        </>
                    )}
                </Typography>
                <Box sx={{ mx: '40px', my: '20px' }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <MUIFormFileInput
                            name="eventsFile"
                            control={control}
                            fileTypes=".csv"
                            fileTypesDescription="CSV"
                            processing={processing}
                            onChange={() => { setShowErrorMessage(false); setErrorMessage(null) }}
                            gxid="btnImportEventsBrowseFiles"
                        />
                        {showErrorMessage && (
                            <Box>
                                <p style={{ color: '#d32f2f' }}>
                                    Import failed.
                                    {' '}
                                    {errorMessage}
                                    {' '}
                                    Please try again.
                                </p>
                            </Box>
                        )}
                    </form>
                </Box>
            </ModalContainer>
        </div>
    )
}

export default ImportEventsModal
